import { Row, Col } from "reactstrap";
import ExitIcon from "./../../Images/black-x.png";

import Text1 from "./Text/Text1";
import Text2 from "./Text/Text2";
import Text3 from "./Text/Text3";
import Text4 from "./Text/Text4";
import Text5 from "./Text/Text5";
import Text6 from "./Text/Text6";
import Text7 from "./Text/Text7";
import Text8 from "./Text/Text8";
import Text9 from "./Text/Text9";
import Text10 from "./Text/Text10";
import Text12 from "./Text/Text12";
import Text13 from "./Text/Text13";
import Text14 from "./Text/Text14";

const HelpModalTrial = ({
  setHelpModalActive,
  helpModalContent,
  setHelpModalContent,
}) => {
  return (
    <Row className="outer-box" onClick={() => setHelpModalActive(false)}>
      <Col className="inner-box p-3 pb-5" onClick={(e) => e.stopPropagation()}>
        {/*** Exit button  ***/}
        <Row className="g-0">
          <Col
            xs={1}
            className="offset-39 d-flex justify-content-center align-items-center help-modal-delete-button"
            onClick={() => setHelpModalActive(false)}
          >
            <img
              src={ExitIcon}
              alt="Delete icon"
              className="img-fluid max-width:100% height:auto mx-auto d-block "
            />
          </Col>
        </Row>

        <Row className="g-0">
          {/*** Menu ***/}
          <Col xs={12} className="border-end ps-3 helpmodal-menu">
            <Row className="g-0">
              <Col
                xs={40}
                className={
                  helpModalContent === "1.0"
                    ? "help-modal-navlink-focused"
                    : "help-modal-navlink"
                }
                onClick={() => setHelpModalContent("1.0")}
              >
                Om <i>din</i>BiZ
              </Col>
            </Row>
            <Row className="g-0 mt-1">
              <Col
                xs={40}
                className={
                  helpModalContent === "2.0"
                    ? "help-modal-navlink-focused"
                    : "help-modal-navlink"
                }
                onClick={() => setHelpModalContent("2.0")}
              >
                Vad är lönsamhet?
              </Col>
            </Row>
            <Row className="g-0 mt-1">
              <Col
                xs={40}
                className={
                  helpModalContent === "3.0"
                    ? "help-modal-navlink-focused"
                    : "help-modal-navlink"
                }
                onClick={() => setHelpModalContent("3.0")}
              >
                Så funkar <i>din</i>BiZ-analysen
              </Col>
            </Row>

            <Row className="g-0 mt-3">
              <Col
                xs={40}
                className={
                  helpModalContent === "5.0"
                    ? "help-modal-navlink-focused"
                    : "help-modal-navlink"
                }
                onClick={() => setHelpModalContent("5.0")}
              >
                Så här gör du
              </Col>
            </Row>

            <Row className="g-0 mt-1">
              <Col
                xs={40}
                className={
                  helpModalContent === "6.0"
                    ? "help-modal-navlink-focused"
                    : "help-modal-navlink"
                }
                onClick={() => setHelpModalContent("6.0")}
              >
                Förberedelser
              </Col>
            </Row>

            <Row className="g-0 mt-3">
              <Col
                xs={40}
                className={
                  helpModalContent === "4.0"
                    ? "help-modal-navlink-focused"
                    : "help-modal-navlink"
                }
                onClick={() => setHelpModalContent("4.0")}
              >
                Steg för lönsamhet
              </Col>
            </Row>
            <Row className="g-0 mt-1">
              <Col
                xs={40}
                className={
                  helpModalContent === "7.0"
                    ? "help-modal-navlink-focused"
                    : "help-modal-navlink"
                }
                onClick={() => setHelpModalContent("7.0")}
              >
                Optimerad lönsamhet
              </Col>
            </Row>
            <Row className="g-0 mt-1">
              <Col
                xs={40}
                className={
                  helpModalContent === "8.0"
                    ? "help-modal-navlink-focused"
                    : "help-modal-navlink"
                }
                onClick={() => setHelpModalContent("8.0")}
              >
                Dina lönsamhetsnycklar
              </Col>
            </Row>
            <Row className="g-0 mt-1">
              <Col
                xs={40}
                className={
                  helpModalContent === "9.0"
                    ? "help-modal-navlink-focused"
                    : "help-modal-navlink"
                }
                onClick={() => setHelpModalContent("9.0")}
              >
                LönsamhetsModeller
              </Col>
            </Row>
            <Row className="g-o mt-3">
              <Col
                xs={40}
                className={
                  helpModalContent === "12.0"
                    ? "help-modal-navlink-focused"
                    : "help-modal-navlink"
                }
                onClick={() => setHelpModalContent("12.0")}
              >
                Frågor & Svar
              </Col>
            </Row>
            <Row className="g-0 mt-3">
              <Col
                xs={40}
                className={
                  helpModalContent === "10.0"
                    ? "help-modal-navlink-focused"
                    : "help-modal-navlink"
                }
                onClick={() => setHelpModalContent("10.0")}
              >
                Fält- & Rubrikförklaring
              </Col>
            </Row>
            <Row className="g-o mt-1">
              <Col
                xs={40}
                className={
                  helpModalContent === "14.0"
                    ? "help-modal-navlink-focused"
                    : "help-modal-navlink"
                }
                onClick={() => setHelpModalContent("14.0")}
              >
                Dina Data
              </Col>
            </Row>
            {/* Note: "Ditt konto" (11.0) is intentionally removed for trial mode */}
            <Row className="g-o mt-1">
              <Col
                xs={40}
                className={
                  helpModalContent === "13.0"
                    ? "help-modal-navlink-focused"
                    : "help-modal-navlink"
                }
                onClick={() => setHelpModalContent("13.0")}
              >
                Kontakt
              </Col>
            </Row>
          </Col>

          {/*** Content  ***/}
          <Col xs={28}>
            <div className="help-modal-scrollbox ps-5 pe-5">
              {helpModalContent === "1.0" ? (
                <Text1 />
              ) : helpModalContent === "2.0" ? (
                <Text2 />
              ) : helpModalContent === "3.0" ? (
                <Text3 />
              ) : helpModalContent === "4.0" ? (
                <Text4 />
              ) : helpModalContent === "5.0" ? (
                <Text5 />
              ) : helpModalContent === "6.0" ? (
                <Text6 />
              ) : helpModalContent === "7.0" ? (
                <Text7 />
              ) : helpModalContent === "8.0" ? (
                <Text8 />
              ) : helpModalContent === "9.0" ? (
                <Text9 />
              ) : helpModalContent === "10.0" ? (
                <Text10 />
              ) : helpModalContent === "12.0" ? (
                <Text12 />
              ) : helpModalContent === "13.0" ? (
                <Text13 />
              ) : helpModalContent === "14.0" ? (
                <Text14 />
              ) : (
                ""
              )}
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};
export default HelpModalTrial;
